import theme from "./theme";

const styles = {
  authorPic: {
    width: "122px",
    height: "122px",
    position: "relative",
    border: "1px solid samoyedWhite",
    borderRadius: "50%",
    overflow: "hidden",
  },
  newComment: {
    textArea: {
      font: "inherit",
      resize: "vertical",
      borderColor: "lightGray",
      borderRadius: "6px",
      p: "12px",
      "::placeholder": {
        color: "lightGray",
      },
    },
  },
  comments: {
    container: {
      ...theme.colToRow,
      gap: ["8px", "8px", "32px"],
      alignItems: "flex-start",
    },
    authorAndDate: {
      justifyContent: "space-between",
      alignItems: "center",
      width: ["100%", "100%", "20%"],
    },
    auhtorInfo: {
      ...theme.rowToCol,
      ...theme.halfToFull,
      gap: "12px",
      alignItems: "center",
      justifyContent: "center",
    },
    contentSection: {
      flexDirection: "column",
      gap: "4px",
      width: ["100%", "100%", "80%"],
    },
    userPicBox: {
      width: ["32px", "32px", "64px"],
      height: ["32px", "32px", "64px"],
    },
    userPic: {
      width: ["32px", "32px", "64px"],
      height: ["32px", "32px", "64px"],
      position: "relative",
      border: "1px solid white",
      borderRadius: "50%",
      overflow: "hidden",
    },
    author: {
      fontSize: "16px",
      lineHeight: "20px",
      fontWeight: 400,
      textAlign: ["inherit", "inherit", "center"],
    },
    date: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 400,
      fontStyle: "italic",
      color: "springGreen",
    },
    content: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 400,
      my: "-10px",
      textAlign: "left",
      whiteSpace: "pre-line",
    },
  },
};

export default styles;
